import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserDetailsResource } from "../models";

@Injectable({ providedIn: "root" })
export class UsersService {
    private httpClient = inject(HttpClient);

    public getUserById$(userId: string): Observable<UserDetailsResource> {
        return this.httpClient.get<UserDetailsResource>(`/api/users/${userId}`);
    }
}
